import { render, staticRenderFns } from "./wheat.vue?vue&type=template&id=335dc32c&scoped=true&"
import script from "./wheat.vue?vue&type=script&lang=js&"
export * from "./wheat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335dc32c",
  null
  
)

export default component.exports